import { ApiService } from '@/services'
import { CodeList } from '@/models/CodeList'

type CouponCodesState = {
  loading: boolean
  codeLists: CodeList[]
}

const state: CouponCodesState = {
  loading: false,
  codeLists: [],
}

const getters = {
  loading: () => state.loading,
  codeLists: () => state.codeLists,
}

const actions = {
  refresh({ commit }) {
    commit('loading', true)
    ApiService.get('coupon/codeLists').then((response) => {
      commit('refresh', response.data)
      commit('loading', false)
    })
  },
}

const mutations = {
  loading(state: CouponCodesState, loading: boolean) {
    state.loading = loading
  },
  refresh(state: CouponCodesState, codeLists: CodeList[]) {
    state.codeLists = codeLists.map((codeList) => {
      codeList.total_codes = codeList.codes.length
      codeList.used_codes = codeList.codes.filter((code) => code.used_by).length
      codeList.used_percentage = Math.round((100 * codeList.used_codes) / codeList.total_codes)

      return codeList
    })
  },
}

export const couponCodes = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
